import Layout from '@/components/feature/Layout';

export default function ReclamosPage() {
  return (
    <Layout>
      <div className="bg-primary-900 py-16 md:py-24">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-400 mb-3">
            Atención
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Reclamos y Sugerencias
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Tu opinión es importante para mejorar nuestro servicio. Escribinos por WhatsApp y te responderemos a la brevedad.
          </p>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-xl mx-auto">
          <div className="p-8 md:p-10 rounded-xl bg-background-50 border border-background-200/70 text-center">
            <div className="w-16 h-16 rounded-2xl bg-green-50 flex items-center justify-center mx-auto mb-6">
              <i className="ri-whatsapp-line text-green-500 text-2xl w-8 h-8 flex items-center justify-center"></i>
            </div>

            <h2 className="font-heading font-semibold text-xl text-foreground-950 mb-3">
              Contactanos por WhatsApp
            </h2>
            <p className="text-sm text-foreground-600 mb-8 max-w-md mx-auto leading-relaxed">
              Para presentar un reclamo, sugerencia o consulta sobre el servicio de agua, escribinos directamente por WhatsApp. Te atenderemos durante nuestro horario de atención.
            </p>

            <a
              href="https://wa.me/59173455233?text=Hola%20CODESAJAN,%20quisiera%20presentar%20un%20reclamo%20o%20sugerencia"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-xl transition-all duration-300 hover:-translate-y-0.5 text-base"
            >
              <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
              Enviar mensaje por WhatsApp
            </a>

            <p className="text-xs text-foreground-400 mt-6">
              Respondemos de lunes a viernes de 08:00 a 16:30 y sábados de 08:00 a 12:00.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}